module.exports = __webpack_public_path__ + "optimal.png?b3a41c075f4ae736bb8efedae0c7c967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/optimal.png
// module id = 191
// module chunks = 0